import React, { useState, useEffect, Fragment, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

import { makeStyles } from "@mui/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { Payment, Add, OpenInNew } from "@mui/icons-material";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import clsx from "clsx";
import { DataGrid } from "@mui/x-data-grid";
import Moment from "moment";
import axios from "axios";
import {
  Alert,
  Grid,
  Box,
  DialogContent,
  DialogActions,
  Dialog,
} from "@mui/material";

import errorImg from "assets/img/error.png";
import successImg from "assets/img/success.gif";
import loaderGif from "assets/img/loading.gif";

import {
  ButtonStyle0,
  cardBodyStyle,
  ButtonExit,
  ButtonTableGrid1,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function ViewsInvoicesAdmin(props) {
  const classes = useStyles();

  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [rows, setRows] = useState([]);
  const [loaderGenerate, setLoaderGenerate] = useState(false);
  const [generate, setGenerate] = useState(false);
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [disabledGenerate, setDisabledGenerate] = React.useState(false);
  const [disabledClose, setDisabledClose] = React.useState(false);
  const [responseInvoices, setResponseInvoices] = React.useState({
    msg: "",
    img: "",
  });

  const { urlServices, UserAuth, ViewFactGenerate } =
    useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [state] = useState({
    columns: [
      {
        headerName: "Documento",
        field: "invoiceDocument",
        flex: 1,
        // headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        renderCell: (params) => {
          return (
            <b style={{ color: params.value !== "0" ? "#000" : "red" }}>
              {params.value !== "0" ? params.value : "Documento no generado"}
            </b>
          );
        },
        // align: "center",
        sortable: false,
        hideable: false,
      },
      {
        headerName: "Factura",
        field: "responseMessage",
        width: 200,
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        renderCell: (params) => {
          return (
            <ButtonTableGrid1
              style={{
                fontSize: 10,
                display: params.row.invoiceDocument !== "0" ? "flex" : "none",
              }}
              component="a"
              target="_blank"
              href={`${ViewFactGenerate}${params.row.responseMessage?.claveAcceso}`}
            >
              Ver factura <OpenInNew sx={{ fontSize: 16, ml: 0.3 }} />
            </ButtonTableGrid1>
          );
        },
        align: "center",
        sortable: false,
        hideable: false,
      },
      {
        headerName: "Estado",
        field: "status",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          let status = params.value === 1 ? "APROBADA" : "ERROR";
          return (
            <b
              style={{
                fontSize: 12,
                color: status === "APROBADA" ? "green" : "red",
              }}
            >
              {status}
            </b>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 150,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Fecha Creación",
        field: "createdAt",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return <span>{Moment(params.value).format("DD-MM-YYYY")} </span>;
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 120,
        sortable: false,
        filtering: false,
        hideable: false,
      },
    ],
  });

  useEffect(() => {
    if (props.id.data.invoiceHistory?.length > 0) {
      RefreshTable();
    }
  }, [props.id.data.invoiceHistory]); // Añadimos la dependencia

  const RefreshTable = () => {
    try {
      setLoader(true);

      const transformedRows = props.id.data.invoiceHistory.map((data) => {
        try {
          return {
            ...data,
            invoiceJson: JSON.parse(data.invoiceJson),
            responseMessage:
              data.invoiceDocument !== "0"
                ? JSON.parse(data.responseMessage)
                : data.responseMessage,
          };
        } catch (error) {
          console.error("Error parsing JSON for row:", data, error);
          return {
            ...data,
            invoiceJson: {},
            responseMessage: data.responseMessage,
          };
        }
      });

      const hasDisabledItems = transformedRows.some((res) => res.status === 1);
      setDisabledGenerate(!hasDisabledItems);
      setRows(transformedRows);
    } catch (error) {
      console.error("Error refreshing table:", error);
      // Podrías añadir aquí un manejo de errores para el usuario
    } finally {
      setLoader(false);
    }
  };

  const GenerateValue = () => async () => {
    setError(false);
    setGenerate(true);
    setLoaderGenerate(true);
    setDisabledClose(true);

    const values = {
      body: props.id.data,
    };

    try {
      const response = await axios.post(
        `${urlServices}invoice-history`,
        values,
        {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        }
      );

      if (response.status === 201) {
        setResponseInvoices({
          msg: "Factura generada con éxito.",
          img: successImg,
        });
      }
    } catch (error) {
      handleError(error);

      setResponseInvoices({
        msg: "Hay un error en generar la factura.",
        img: errorImg,
      });
    } finally {
      setLoaderGenerate(false);
      props.callBackRefresh();
      setDisabledClose(false);

      setTimeout(() => {
        props.exit();
      }, 5000);
    }

    /*setError(false);
    setGenerate(true);
    setLoaderGenerate(true);
    setDisabledClose(true);

    let newData = {
      ...props.id.data.client,
      prefix: JSON.parse(props.id.data.client.prefix),
    };

    const values = {
      clients: newData,
      product: props.id.data.productsJson[0],
      paytransaction: props.id.pay,
    };

    try {
      const response = await axios.post(
        `${urlServices}invoice-history-contifico`,
        values,
        {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        }
      );

      if (response.status === 201) {
        setResponseInvoices({
          msg: "Factura generada en contifico con éxito.",
          img: successImg,
        });
      }
    } catch (error) {
      handleError(error);

      setResponseInvoices({
        msg: "Hay un error en generar la factura.",
        img: errorImg,
      });
    } finally {
      setLoaderGenerate(false);
      RefreshTable();
      setDisabledClose(false);
    }*/
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  /*const handleCloseGenerate = () => {
    setGenerate(false);
  };*/

  // Manejo común de errores
  const handleError = (error) => {
    if (error.response?.status === 401) {
      setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
      setError(true);
      setTimeout(() => {
        localStorage.clear();
        setReturnLogin(true);
      }, 4000);
    }
    if (error.response?.status === 404) {
      setMensageSystem("Registro no encontrado.");
      setError(true);
    } else if (error.response?.status === 500) {
      setMensageSystem("Error en la consulta con el servidor.");
      setError(true);
    } else {
      console.error("Error en la solicitud:", error);
      setMensageSystem("Error al realizar la solicitud.");
      setError(true);
    }
  };

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="md"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        // style={{ zIndex: 100 }}
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.cardTitleBlack}>
                <Payment className={classes.iconFilter} /> Facturación
              </div>
              <Card>
                <CardBody>
                  <Fragment>
                    <Grid container>
                      <Grid item xs={12} sm={12}>
                        {error && (
                          <Alert severity="error">{mensageSystem}</Alert>
                        )}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        sx={{ display: disabledGenerate ? "block" : "none" }}
                      >
                        <div style={{ float: "right" }}>
                          <ButtonStyle0
                            onClick={GenerateValue()}
                            endIcon={<Add />}
                          >
                            Generar factura
                          </ButtonStyle0>
                        </div>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        sx={{
                          display: UserAuth.profile_id === 1 ? "block" : "none",
                        }}
                      >
                        <Alert severity="warning" sx={{ fontSize: 12 }}>
                          Las ordenes <b>PAGADAS</b> que esten dentro de las{" "}
                          <b>24 HORAS</b> a la fecha, pueden ser reembolsadas y
                          si se pasó de la fecha debe comunicarse con la
                          pasarela de pago.
                        </Alert>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        {loader ? (
                          <center>
                            <img
                              alt="loaderGif"
                              src={loaderGif}
                              style={{ width: 60, margin: "8% 0" }}
                            />
                          </center>
                        ) : (
                          <Box
                            sx={{
                              "& .super-app.celAll": {
                                fontSize: 12,
                                //backgroundColor: 'rgba(255, 7, 0, 0.55)',
                              },
                              "& .super-app.celActions": {
                                backgroundColor: "rgb(242, 242, 242)",
                              },
                              "& .super-app-theme--header": {
                                backgroundColor: "rgb(242, 242, 242)",
                              },
                              "& .super-app.wordWrap": {
                                fontSize: 10,
                                wordWrap: "break-word !important",
                                whiteSpace: "normal !important",
                              },
                              marginTop: 2,
                            }}
                          >
                            <DataGrid
                              rows={rows}
                              columns={state.columns}
                              initialState={{
                                pagination: {
                                  paginationModel: { page: 0, pageSize: 10 },
                                },
                              }}
                              pageSizeOptions={[5, 10, 20, 50]}
                              disableRowSelectionOnClick={true}
                              checkboxSelection={false}
                              //rowHeight={40}
                              autoHeights
                            />
                          </Box>
                        )}
                      </Grid>
                    </Grid>
                  </Fragment>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
          {/* Modal */}
          <Dialog
            open={generate}
            maxWidth="sm"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: 6,
              },
            }}
          >
            <DialogContent>
              <center>
                {loaderGenerate ? (
                  <>
                    <img
                      alt="loaderGif"
                      src={loaderGif}
                      style={{ width: 60, margin: "8% 0 1% 0" }}
                    />
                    <div
                      className={classes.cardTitleBlack}
                      style={{ fontSize: 14, marginBottom: 20 }}
                    >
                      Generando factura
                    </div>
                  </>
                ) : (
                  <>
                    <img
                      alt="msgImg"
                      src={responseInvoices.img}
                      style={{ width: 100, margin: "8% 0 1% 0" }}
                    />
                    <div
                      className={classes.cardTitleBlack}
                      style={{ fontSize: 16, marginBottom: 20 }}
                    >
                      {responseInvoices.msg}
                    </div>
                    <br></br>
                    <b>Cerrando ventana...</b>
                  </>
                )}
              </center>
            </DialogContent>
            {/*<DialogActions>
              <ButtonExit
                disabled={disabledClose}
                onClick={handleCloseGenerate}
              >
                Cerrar
              </ButtonExit>
            </DialogActions>*/}
          </Dialog>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialog(true)}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
